// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uaMI","colBig":"styles_colBig__2GQGc","colSmall":"styles_colSmall__-_DQf","shopifyNameWrapper":"styles_shopifyNameWrapper__1h78H"};